import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../Assets/logo.svg";
import CrudContext from "../context/crudContext";
import FormContext from "../context/formContext";
import "../styles/header.css";

export default function Header() {
  const { setDataToEdit, setAuth } = useContext(CrudContext);

  const { setForm, initialForm } = useContext(FormContext);

  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/administrador");
  };

  const handleAdd = () => {
    navigate("/agregar");
    setForm(initialForm);
    setDataToEdit(null);
  };

  const handleLogout = () => {
    setAuth(false);
    navigate("/");
  };

  if (window.location.hash === "") return null;
  if (window.location.hash === "#/") return null;
  return (
    <>
      <header>
        <div className="header">
          <img
            style={{ cursor: "pointer" }}
            onClick={handleClick}
            className="logo"
            src={logo}
            alt={logo}
          />

          <div className="personContainer">
            <div className="personInfo">
              <button onClick={handleAdd} className="addBtn">
                Agregar +
              </button>
            </div>
            <div>
              <i
                className="bx bx-exit"
                onClick={handleLogout}
                style={{
                  color: "#703bda",
                  fontSize: "25px",
                  cursor: "pointer",
                }}
              ></i>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
